export const parseText = (text: string | undefined) => {
  if (!text) return '';
  return text
    .replace(/&nbsp;/g, '\u00A0')
    .replace(/&mdash;/g, '\u2014')
    .replace(/&laquo;/g, '\u00AB')
    .replace(/&raquo;/g, '\u00BB')
    .replace(/&quot;/g, '"')
    .replace(/&#37;/g, '%')
    .replace(/&#40;/g, '(')
    .replace(/&#41;/g, ')')
    .replace(/&#43;/g, '+')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/<br>/g, '\n');
};
